import React from 'react';

const Skeleton = ({ type = 'text', count = 1, className = '' }) => {
    const renderSkeleton = () => {
        switch (type) {
            case 'card': // For Dashboard/Lecture Grids
                return (
                    <div className={`bg-white p-4 rounded-xl shadow-sm border border-gray-100 animate-pulse ${className}`}>
                        <div className="h-32 bg-gray-200 rounded-lg mb-4"></div>
                        <div className="h-4 bg-gray-200 rounded w-3/4 mb-2"></div>
                        <div className="h-3 bg-gray-200 rounded w-1/2"></div>
                    </div>
                );
            case 'row': // For Exam Lists/Tables
                return (
                    <div className={`flex items-center gap-4 p-4 border rounded-lg bg-white border-gray-100 animate-pulse mb-2 ${className}`}>
                        <div className="h-10 w-10 bg-gray-200 rounded-lg"></div>
                        <div className="flex-1 space-y-2">
                            <div className="h-4 bg-gray-200 rounded w-1/3"></div>
                            <div className="h-3 bg-gray-200 rounded w-1/4"></div>
                        </div>
                        <div className="h-8 w-20 bg-gray-200 rounded"></div>
                    </div>
                );
            case 'question': // For ExamTaker
                return (
                    <div className={`p-6 border rounded-lg bg-gray-50 space-y-4 animate-pulse ${className}`}>
                        <div className="h-4 bg-gray-200 rounded w-1/6 mb-4"></div> {/* Section Title */}
                        <div className="h-6 bg-gray-200 rounded w-3/4"></div> {/* Question Text */}
                        <div className="h-6 bg-gray-200 rounded w-full"></div>
                        <div className="h-6 bg-gray-200 rounded w-2/3"></div>
                        
                        <div className="space-y-3 mt-8">
                            {[1, 2, 3, 4].map(i => (
                                <div key={i} className="flex items-center gap-3 p-3 border rounded bg-white">
                                    <div className="h-5 w-5 bg-gray-200 rounded"></div>
                                    <div className="h-4 bg-gray-200 rounded flex-1"></div>
                                </div>
                            ))}
                        </div>
                    </div>
                );
            case 'folder': // For Topic Manager
                return (
                    <div className={`bg-white p-6 rounded-lg shadow border animate-pulse h-40 flex flex-col items-center justify-center ${className}`}>
                        <div className="h-10 w-10 bg-gray-200 rounded mb-3"></div>
                        <div className="h-4 bg-gray-200 rounded w-2/3 mb-2"></div>
                        <div className="h-3 bg-gray-200 rounded w-1/3"></div>
                    </div>
                );
            default: // Simple text line
                return <div className={`bg-gray-200 rounded animate-pulse ${className}`}></div>;
        }
    };

    return (
        <div className={type === 'card' || type === 'folder' ? "grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-6" : "w-full"}>
            {Array(count).fill(0).map((_, i) => (
                <div key={i} className={type === 'card' || type === 'folder' ? 'w-full' : 'w-full'}>
                    {renderSkeleton()}
                </div>
            ))}
        </div>
    );
};

export default Skeleton;